import React from 'react';
import './FilePreview.scss';
import { Drive as DriveAPI } from '../../api';
import * as DriveHelper from '../../helpers/Drive';
import { FILE_EXTENSIONS_PREVIWABLE } from '../../pages/Drive/FileSearch';
import { T } from '../../helpers/Language';

export const TypeToComponent = {
    'application/pdf': (srcURL) => (
        <iframe title="preview" className="file-element-preview" src={srcURL} />
    ),
    image: (srcURL) => (
        <img
            className="file-element-preview"
            alt="file-preview"
            src={srcURL}
            style={{ width: '100%', minHeight: '310px' }}
        />
    ),
    default: (srcURL) => (
        <iframe title="preview" className="file-element-preview" src={srcURL} />
    ),
};

function propsAreEqual(prevProps, nextProps) {
    return prevProps.fileElement === nextProps.fileElement;
}

const FilePreview = React.memo(({ fileElement, fallback }) => {
    if (!fileElement) return fallback();

    if (
        fileElement.fileExtension &&
        !FILE_EXTENSIONS_PREVIWABLE.includes(fileElement.fileExtension)
    ) {
        return (
            <div className="cannot-preview">
                <p>{T('DRIVE_FEXPLORER_CANNOT_PREVIEW')}</p>
            </div>
        );
    }

    if (fileElement._isFetching) {
        return (
            <div className="cloud-loader-box">
                <span className="loaderCloud"></span>
            </div>
        );
    }
    const type = DriveHelper.FileElement.getSimplifiedType(fileElement);
    const srcURL = DriveAPI.downloadFileHardLink(fileElement.id);
    const componentFunc = TypeToComponent[type] || TypeToComponent.default;
    return componentFunc(srcURL);
}, propsAreEqual);

export default FilePreview;
